import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const category = 'registry';
const pagePrefix = 'admin';

export enum Page {
  'shop' = 'shop',
  'manage' = 'manage',
  'overview' = 'overview',
  'addItemDrawer' = 'addItemDrawer',
  'giftsDrawer' = 'giftsDrawer'
}

interface RegistryCheatSheetExpandedArgs {
  targetGiftCount: number;
  currentGiftCount: number;
  page: Page;
}

export const registryGiftCountsTelemetry = createTelemetryObject({
  actions: {
    registryCheatSheetSaved: (guestCount: number, page: Page) => ({
      action: 'RegistryCheatSheetSaved',
      actionType: undefined,
      pagePrefix,
      page,
      category,
      extraInfo: {
        guestCount
      }
    }),
    cheatSheetPricePointClicked: (label: string, page: Page) => ({
      action: 'CheatSheetPricePoint',
      actionType: 'click',
      pagePrefix,
      page,
      category,
      extraInfo: {
        label
      }
    }),
    registryCheatSheetExpanded: ({ targetGiftCount, currentGiftCount, page, ...rest }: RegistryCheatSheetExpandedArgs) => ({
      action: 'RegistryCheatSheetExpanded',
      actionType: undefined,
      pagePrefix,
      page,
      category,
      extraInfo: {
        targetGiftCount,
        currentGiftCount,
        ...rest
      }
    })
  }
});

const { TelemetryProvider, useTelemetry } = createTelemetry(registryGiftCountsTelemetry, { eventId: '' });

const useRegistryGiftCountsTelemetry = useTelemetry;

export { TelemetryProvider, useRegistryGiftCountsTelemetry };
